<template>
  <div class="szw-col szw-w-full">
    <table-header :headerCells="headings" :highlightedCells="[0]" />

    <!-- skeleton  -->
    <template v-if="status === 'loading'">
      <div class="szw-tbl-row__no-border szw-py-0">
        <div class="szw-col szw-w-full szw-mr-auto">
          <div class="szw-flex szw-items-center szw-justify-center szw-tbl-row__name-section szw-h-[37px]">
            <span class="szw-w-24 szw-h-4 szw-rounded szw-bg-section-static szw-animate-pulse" />
          </div>

          <div class="szw-flex szw-items-center szw-justify-center szw-tbl-row__name-section szw-h-[37px]">
            <span class="szw-w-24 szw-h-4 szw-rounded szw-bg-section-static szw-animate-pulse" />
          </div>
        </div>

        <div class="szw-col szw-w-fit last:szw-border-bottom szw-h-[74px] szw-justify-between" v-for="period of 4" :key="period">
          <div class="szw-tbl-cell szw-flex szw-items-center szw-justify-center szw-h-[37px]">
            <span class="szw-w-5 szw-h-4 szw-rounded szw-bg-section-static szw-animate-pulse" />
          </div>

          <div class="szw-tbl-cell szw-flex szw-items-center szw-justify-center szw-h-[37px]">
            <span class="szw-w-5 szw-h-4 szw-rounded szw-bg-section-static szw-animate-pulse" />
          </div>
        </div>
      </div>
    </template>

    <template v-if="status === 'success'">
      <div class="szw-tbl-row__no-border szw-py-0">
        <div class="szw-col szw-w-full szw-mr-auto">
          <div class="szw-flex szw-items-center szw-justify-start szw-h-[37px]">
            <span class="szw-tbl-row__name-section">
              {{ homeTeam.name }}
            </span>
          </div>
          <div class="szw-flex szw-items-center szw-justify-start szw-h-[37px]">
            <span class="szw-tbl-row__name-section">
              {{ awayTeam.name }}
            </span>
          </div>
        </div>

        <div class="szw-col szw-w-fit last:szw-border-bottom szw-h-[74px] szw-justify-between" v-for="(period, index) of periods" :key="index">
          <div :class="`${!isSmallWidgetContainerSize ? 'szw-tbl-cell' : 'szw-tbl-cell_medium'} szw-flex szw-items-center szw-justify-center szw-h-[37px]`">
            <span :class="{ 'szw-bg-latest-background-color-secondary szw-py-0.5 szw-px-1.5 szw-rounded': period.home > period.away }">{{ period.home }}</span>
          </div>

          <div :class="`${!isSmallWidgetContainerSize ? 'szw-tbl-cell' : 'szw-tbl-cell_medium'} szw-flex szw-items-center szw-justify-center szw-h-[37px]`">
            <span :class="{ 'szw-bg-latest-background-color-secondary szw-py-0.5 szw-px-1.5 szw-rounded': period.away > period.home }">{{ period.away }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import TableHeader from '@/__core__/components/table/header/TableHeader.vue'
import { computed, inject } from 'vue'
import { FALLBACK_PERIODS } from './PeriodOverview.constants'
import { loc } from '@/__core__/localization/localization'

/** @typedef {{
 *   home: number,
 *   away: number,
 *   periodLabel: string
 *  }} Period */
/** @type {{
 *   periods: Period[]
 *  }}
 */
const props = defineProps({
  homeTeam: {
    type: Object,
    default: () => ({})
  },
  awayTeam: {
    type: Object,
    default: () => ({})
  },
  periods: {
    type: Array,
    default: () => []
  }
})

const status = inject('status')
const langId = inject('langId', '')
const isSmallWidgetContainerSize = inject('isSmallWidgetContainerSize')

const headings = computed(() => (status.value === 'loading' ? FALLBACK_PERIODS : [loc('standings_team', langId), ...props.periods.map(period => period.periodLabel)]))
</script>
